import { Parameters, RequestContext } from 'DVWebNodeUtils'
import { makeUrl } from './urlGen'

export interface IUrlData {
  parameters: Parameters
  originalURI: string
}

const removeRef = (parameters: Parameters) => {
  const copiedParams = Object.assign({}, parameters)
  delete copiedParams['ref_']
  return copiedParams
}

export const buildCurrentUrlWithLocaleReftag = (context: RequestContext, refTag: string) => {
  const urlData: IUrlData = { parameters: removeRef(context.parameters), originalURI: context.originalURI }
  return makeUrl(context.path, {urlData, get: {
    ie: 'UTF8'
  }, refTag})
}
